/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 document.addEventListener('DOMContentLoaded',function(){
var wrap=document.querySelector('.ttc-usecase-wrap');

function normalize(value){
return String(value||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
}

function findFilter(tag){
var target=normalize(tag);
var inputs=document.querySelectorAll('#desktop-filters-form input[type="checkbox"],#mobile-collection-filters-form input[type="checkbox"]');

for(var i=0;i<inputs.length;i++){
if(normalize(inputs[i].value)===target){
return inputs[i];
}
}

return null;
}

function syncUseCases(){
if(!wrap)return;

var cards=wrap.querySelectorAll('.ttc-usecase-card');

for(var i=0;i<cards.length;i++){
var card=cards[i];
var input=findFilter(card.getAttribute('data-usecase'));
var active=!!(input&&input.checked);

if(active){
card.classList.add('ttc-usecase-card--active');
card.setAttribute('aria-pressed','true');
}else{
card.classList.remove('ttc-usecase-card--active');
card.setAttribute('aria-pressed','false');
}
}
}

function refreshUseCases(){
syncUseCases();
setTimeout(syncUseCases,200);
setTimeout(syncUseCases,500);
setTimeout(syncUseCases,1000);
}

if(wrap){
wrap.addEventListener('click',function(event){
var card=event.target.closest('.ttc-usecase-card');

if(!card)return;

var input=findFilter(card.getAttribute('data-usecase'));

if(!input)return;

input.click();
refreshUseCases();
});
}

document.addEventListener('change',function(event){
var target=event.target;

if(!target.matches('#desktop-filters-form input[type="checkbox"],#mobile-collection-filters-form input[type="checkbox"]')){
return;
}

refreshUseCases();
});

document.addEventListener('click',function(event){
var clearButton=event.target.closest('[data-action="clear-filters"]');

if(!clearButton)return;

setTimeout(refreshUseCases,100);
});

syncUseCases();

var wrapper=document.querySelector('[data-ttc-desc]');

if(!wrapper)return;

var content=wrapper.querySelector('[data-ttc-desc-content]');
var button=wrapper.querySelector('[data-ttc-desc-toggle]');

if(!content||!button)return;

if(content.scrollHeight<=content.clientHeight){
button.style.display='none';
return;
}

button.addEventListener('click',function(){
content.classList.toggle('is-expanded');

var expanded=content.classList.contains('is-expanded');

button.textContent=expanded?'Read Less':'Read More';
button.setAttribute('aria-expanded',expanded);
});
});

//addcart

(function(){

  // UPDATE CART COUNT
  function updateCartCount(cart){

    var count = cart.item_count;

    document.querySelectorAll(
      '[data-cart-count], .cart-count, .header__cart-count, .cart-count-bubble span'
    ).forEach(function(el){

      el.textContent = count;
      el.classList.toggle('hidden', count === 0);

    });

    document.querySelectorAll('[data-cart-count-bubble]').forEach(function(el){

      el.textContent = count;
      el.classList.toggle('hidden', count === 0);

    });

  }


  // ADD TO CART - OPTIMIZED
  function addToCart(form, button){

    if(button.dataset.adding === 'true') return;

    button.dataset.adding = 'true';

    var originalText = button.dataset.originalText || button.textContent.trim();

    button.dataset.originalText = originalText;

    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Adding...';

    var formData = new FormData(form);

    fetch('/cart/add.js',{
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    })

    .then(function(response){

      if(!response.ok){

        return response.json().then(function(error){
          throw error;
        });

      }

      return response.json();

    })

    .then(function(){

      // Show success immediately
      button.textContent = 'Added';

      button.classList.remove('is-loading');
      button.classList.add('is-added');

      // Update cart count in background
      fetch('/cart.js',{
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json'
        }
      })

      .then(function(response){

        if(!response.ok){
          throw new Error('Cart count update failed');
        }

        return response.json();

      })

      .then(function(cart){

        updateCartCount(cart);

      })

      .catch(function(error){

        console.error('Cart count error:', error);

      });


      // Reset button
      setTimeout(function(){

        button.textContent = originalText;
        button.disabled = false;

        button.classList.remove('is-loading');
        button.classList.remove('is-added');

        button.dataset.adding = 'false';

      }, 1000);

    })

    .catch(function(error){

      console.error('Add to cart error:', error);

      button.textContent = 'Try Again';

      button.disabled = false;
      button.classList.remove('is-loading');

      button.dataset.adding = 'false';

    });

  }



  // VARIANT CHANGE
  function updateVariant(select){

    var option = select.options[select.selectedIndex];

    if(!option) return;

    var card = select.closest('.product-item');

    if(!card) return;

    var imageUrl = option.getAttribute('data-image-url');
    var mediaId = option.getAttribute('data-media-id');
    var aspectRatio = option.getAttribute('data-image-aspect-ratio');
    var variantUrl = option.getAttribute('data-variant-url');
    var variantId = option.value;

    var image = card.querySelector('.product-item__primary-image');
    var imageLink = card.querySelector('.product-item__image-wrapper');
    var imageContainer = card.querySelector('.aspect-ratio');
    var titleLink = card.querySelector('.product-item__title');

    var form = select.closest('form');

    var button = form ? form.querySelector('.ttc-fc__add') : null;


    // UPDATE IMAGE
    if(imageUrl && image){

      image.style.opacity = '0';

      image.removeAttribute('srcset');
      image.removeAttribute('sizes');

      image.onload = function(){
        image.style.opacity = '1';
      };

      image.onerror = function(){
        image.style.opacity = '1';
      };

      image.src = imageUrl;

      if(mediaId){
        image.setAttribute('data-media-id', mediaId);
      }

      if(aspectRatio && imageContainer){

        var ratio = parseFloat(aspectRatio);

        if(ratio > 0){
          imageContainer.style.paddingBottom = (100 / ratio) + '%';
        }

      }

    }


    // UPDATE PRODUCT URL
    if(variantUrl){

      if(imageLink){
        imageLink.href = variantUrl;
      }

      if(titleLink){
        titleLink.href = variantUrl;
      }

    }


    // UPDATE VARIANT ID
    if(form){

      var hiddenId = form.querySelector('input[name="id"]');

      if(hiddenId){
        hiddenId.value = variantId;
      }

    }


    // UPDATE BUTTON
    if(button){

      var available = option.getAttribute('data-available') === 'true';

      button.disabled = !available;

      button.classList.toggle('button--disabled', !available);
      button.classList.toggle('button--primary', available);
      button.classList.toggle('ttc-soldout', !available);

      button.textContent = available ? 'Add to Cart' : 'Sold out';

    }

  }



  // VARIANT CHANGE EVENT
  document.addEventListener('change',function(event){

    var select = event.target.closest('.ttc-fc__variant');

    if(!select) return;

    updateVariant(select);

  });



  // ADD TO CART BUTTON CLICK
  document.addEventListener('click',function(event){

    var button = event.target.closest('.ttc-fc__add');

    if(!button) return;

    var form = button.closest('form');

    if(!form) return;

    event.preventDefault();
    event.stopPropagation();

    if(button.disabled || button.dataset.adding === 'true') return;

    addToCart(form,button);

  });



  // FORM SUBMIT
  document.addEventListener('submit',function(event){

    var form = event.target.closest('form[action*="/cart/add"]');

    if(!form) return;

    var button = form.querySelector('.ttc-fc__add');

    if(!button) return;

    event.preventDefault();
    event.stopPropagation();

    if(button.disabled || button.dataset.adding === 'true') return;

    addToCart(form,button);

  });


})();



// MOBILE COLLECTION TOOLBAR
(function(){

  function updateToolbar(){

    var toolbar = document.querySelector('.collection__toolbar');

    var menu = document.querySelector('#mobile-menu');

    if(!toolbar || !menu) return;

    var menuOpen = menu.getAttribute('aria-hidden') === 'false';

    toolbar.classList.toggle('menu-hidden', menuOpen);

  }


  updateToolbar();

  var observer = new MutationObserver(updateToolbar);

  var menu = document.querySelector('#mobile-menu');

  if(menu){

    observer.observe(menu,{
      attributes: true,
      attributeFilter: ['aria-hidden','class']
    });

  }

})();


(function () {
  function updateToolbar() {
    var toolbar = document.querySelector('.sticky-add-to-cart');
    var menu = document.querySelector('#mobile-menu');

    if (!toolbar || !menu) return;

    var menuOpen = menu.getAttribute('aria-hidden') === 'false';

    toolbar.classList.toggle('menu-hidden', menuOpen);
  }

  updateToolbar();

  var observer = new MutationObserver(updateToolbar);

  var menu = document.querySelector('#mobile-menu');

  if (menu) {
    observer.observe(menu, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
  }
})();